import { render } from "./WhyShopWithus.vue?vue&type=template&id=6913bf8b"
const script = {}

import "./WhyShopWithus.vue?vue&type=style&index=0&id=6913bf8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__